import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "team-header" }
const _hoisted_2 = {
  key: 0,
  class: "changed-sign"
}
const _hoisted_3 = { class: "team-description" }

import { reactive } from 'vue';
import { DxButton } from 'devextreme-vue';
import TeamMember from './TeamMember.vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import { UserItem } from '@/services/entities/UserItem';
import { useVfm } from "vue-final-modal";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import TeamMemberSelectModal from './dialogs/TeamMemberSelectModal.vue';
import EditTeamPropertiesModal from './dialogs/EditTeamPropertiesModal.vue';
import { showWarning } from '@/toastification';
import { useServiceTeamsStore } from '@/stores/serviceTeams';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTeam',
  props: {
    team: { Type: {} as ServiceTeamItem, default: {} as ServiceTeamItem },
},
  emits: ["reload"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const teamMemberSelectModalId = Symbol("teamMemberSelectModalId");
const teamRenameModalId = Symbol("teamRenameModalId");
const teamsStore = useServiceTeamsStore();

const props = __props;

const emit = __emit;

const state = reactive({
   isSaving: false,
   isDeleting: false, 
   addedUser: {} as UserItem,
   addAsLeader: false,
   changed: false,
});

function getConfirmText() {
    if (state.isSaving) {
        return "Are you sure you want to save changes to this service team?";
    } else if (state.isDeleting) {
        return "Are you sure you want to delete this service team?";
    }
    return "";
}

function getConfirmButtonText() {
    if (state.isSaving) {
        return "Save changes";
    } else if (state.isDeleting) {
        return "Delete team";
    }
    return "Confirm";
}

async function modalConfirmed() {
    if (state.isSaving) {
        const team = teamsStore.getServiceTeams.find(t => t.id === props.team.id);
        if (team) {            
            await teamsStore.updateServiceTeam(props.team);
        } else {
            await teamsStore.createServiceTeam(props.team);
        }
    } else if (state.isDeleting) {
        await teamsStore.deleteServiceTeam(props.team.id);
    }
    emit("reload", props.team.service.id);
    vfm.close(confirmModalId);
    
}



function modalClosed() {
    state.isSaving = false;
    state.isDeleting = false;
    vfm.close(confirmModalId);
}   

function onSaveTeam() {
    state.isSaving = true;
    state.isDeleting = false;
    vfm.open(confirmModalId);    
}

function onRenameTeam() {
    vfm.open(teamRenameModalId);
}

function onAddMember() {
    state.addAsLeader = false;
    state.addedUser = {} as UserItem;
    vfm.open(teamMemberSelectModalId);
}

function onDeleteTeam() {
    state.isDeleting = true;
    state.isSaving = false; 
    vfm.open(confirmModalId);
}

function onRemoveLeader(leader: UserItem) {
    if (leader) {
        let indx = props.team.teamLead.indexOf(leader);
        if (indx > -1) {
            props.team.teamLead.splice(indx, 1)
        }
    }    
}

function onRemoveMember(member: UserItem) {
    if (member) {
        let indx = props.team.members.indexOf(member);
        if (indx > -1) {
            props.team.members.splice(indx, 1)
        }
    }
}

function doDeleteMember(member: UserItem) {

}

function doAddMember(addedUser: UserItem, asLeader: boolean) {
    if (addedUser) {
        if (isAllreadyInTeam(addedUser)) {
            showWarning(`${addedUser.fullName} is already in team`);
            return;
        }
        if (asLeader) {
            if (props.team.teamLead) 
                props.team.teamLead.push(addedUser)
            else
                props.team.teamLead = [addedUser];
            
        } else {
            if (props.team.members)
                props.team.members.push(addedUser);
            else
                props.team.members = [addedUser];
        }        
    }
    vfm.close(teamMemberSelectModalId);
}

function isAllreadyInTeam(user: UserItem): boolean {
    return (props.team.members?.some((u) => u.id == user.id) ||
            props.team.teamLead?.some((l) => l.id == user.id));
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(props.team.teamName), 1),
        (state.changed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(DxButton), {
          hint: "Rename team/Change description",
          icon: "edit",
          "styling-mode": "contained",
          type: "normal",
          onClick: onRenameTeam
        }),
        _createVNode(_unref(DxButton), {
          hint: "Add member",
          icon: "add",
          "styling-mode": "contained",
          type: "normal",
          onClick: onAddMember
        }),
        _createVNode(_unref(DxButton), {
          hint: "Save",
          icon: "save",
          "styling-mode": "contained",
          type: "normal",
          onClick: onSaveTeam,
          disabled: false
        }),
        _createVNode(_unref(DxButton), {
          hint: "Delete team",
          icon: "trash",
          "styling-mode": "contained",
          type: "normal",
          onClick: onDeleteTeam
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.team.description), 1),
    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.teamLead, (leader) => {
      return (_openBlock(), _createElementBlock("div", {
        key: leader.id,
        class: "team-leaders"
      }, [
        _createVNode(TeamMember, {
          "is-team-lead": true,
          member: leader,
          onRemove: onRemoveLeader
        }, null, 8, ["member"])
      ]))
    }), 128)),
    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.members, (member) => {
      return (_openBlock(), _createElementBlock("div", {
        key: member.id,
        class: "team-members"
      }, [
        _createVNode(TeamMember, {
          "is-team-lead": false,
          member: member,
          onRemove: onRemoveMember
        }, null, 8, ["member"])
      ]))
    }), 128)),
    _createVNode(ConfirmModal, {
      "modal-id": _unref(confirmModalId),
      text: getConfirmText(),
      "confirm-text": getConfirmButtonText(),
      onConfirm: modalConfirmed,
      onClose: modalClosed
    }, null, 8, ["modal-id", "text", "confirm-text"]),
    _createVNode(TeamMemberSelectModal, {
      "modal-id": _unref(teamMemberSelectModalId),
      onClose: _cache[0] || (_cache[0] = () => _unref(vfm).close(_unref(teamMemberSelectModalId))),
      onSave: doAddMember,
      "button-caption": 'Add Member',
      user: state.addedUser
    }, null, 8, ["modal-id", "user"]),
    _createVNode(EditTeamPropertiesModal, {
      "modal-id": _unref(teamRenameModalId),
      onClose: _cache[1] || (_cache[1] = () => _unref(vfm).close(_unref(teamRenameModalId))),
      team: props.team
    }, null, 8, ["modal-id", "team"])
  ], 64))
}
}

})